<template>
  <rich-dialog
    class="initI18n-dialog"
    ref="dialog"
    type="alert"
    title="Select Region & Language"
    :visible="true"
    :confirmBtn="confirmBtn"
    @confirm="submitForm"
  >
    <div slot="content" class="i18n-wrapper">
      <soda-form
        ref="form"
        v-model="langForm"
        :config="langConfig"
        @input="selectChange"
      ></soda-form>
    </div>
  </rich-dialog>
</template>

<script type="text/ecmascript-6">
import { setBDLocale, setBDCountry } from '@/common/utils/i18n'
import { setCountryLocale } from '@/api'
import SodaForm from '@/components/form/index'
import { mapState, mapActions } from 'vuex'
import storage from 'didi-store'
import { get } from 'lodash-es'

export default {
  name: 'InitI18n',
  components: {
    SodaForm
  },
  data() {
    return {
      confirmBtn: {
        text: 'Confirm',
        active: true
      },
      languagesOption: [],
      langForm: {
        country: [],
        locale: ''
      }
    }
  },
  computed: {
    ...mapState({
      countryMapLangConf: (state) => state.countryMapLangConf
    }),
    langConfig() {
      return [
        {
          label: this.gettext('地区'),
          prop: 'country',
          props: {
            test: 1
          },
          type: 'countryPicker'
        },
        {
          label: this.gettext('语言'),
          prop: 'locale',
          type: 'select',
          props: {
            options: this.languagesOption
          }
        }
      ]
    }
  },
  created() {
    this.getUserAuthCountry()
  },
  methods: {
    ...mapActions(['getUserAuthCountry']),
    selectChange(value) {
      this.changeLanguage(value.country, value.locale)
    },
    changeLanguage(country, locale) {
      this.langForm.country = country
      const countryName = country[0]
      this.langForm.locale = this.countryMapLangConf[countryName]
        .map((item) => {
          return item.value
        })
        .includes(locale)
        ? locale
        : get(this.countryMapLangConf[countryName], '[2].value')
      this.languagesOption = this.countryMapLangConf[countryName]
    },
    showToast(txt) {
      const toast = this.$createToast({
        txt,
        type: 'warn',
        time: 800
      })
      toast.show()
    },
    submitForm() {
      if (this.langForm.locale && this.langForm.country) {
        setCountryLocale({
          locale: this.langForm.locale,
          country: this.langForm.country[0],
          timezone: this.langForm.country[1]
        })
          .then((res) => {
            setBDLocale(this.langForm.locale)
            setBDCountry(this.langForm.country[0])
            storage.set('language', this.langForm.locale) // 新增代码
            window.location.reload()
          })
          .catch(() => {
            this.$refs.dialog.show()
          })
      } else {
        this.showToast('Region and language are required')
        this.$refs.dialog.show()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.initI18n-dialog {
  ::v-deep .rich-dialog-title-def {
    margin: 18px 16px 0;
    line-height: 32px;
  }
}
.i18n-wrapper {
  padding: 0 10px;
}
.i18n-wrapper ::v-deep .rich-select {
  margin-top: 10px;
}
</style>
